var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1969_589)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 0.506226H0V30.4937H30V0.506226Z",
    fill: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2693 15.5001C21.4807 14.622 22.2688 13.1945 22.2688 11.5846C22.2688 9.09664 20.3892 7.04835 17.9724 6.78107C17.7963 6.76109 17.6165 6.7511 17.4354 6.7511H7.73096V10.1982H16.4112C17.3979 10.1982 18.1972 10.9976 18.1972 11.9842C18.1972 12.9709 17.3979 13.7702 16.4112 13.7702H7.73096V17.2174H16.4112C17.3979 17.2174 18.1972 18.0167 18.1972 19.0034C18.1972 19.9901 17.3979 20.7894 16.4112 20.7894L12.9928 20.8019H7.73096V24.249H17.4354C17.6165 24.249 17.7963 24.239 17.9724 24.219C20.3892 23.9518 22.2688 21.9035 22.2688 19.4155C22.2688 16.9276 21.4807 16.3781 20.2693 15.5001Z",
    fill: "#FFCC01"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1969_589"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 30,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlogo);
export default __webpack_public_path__ + "static/media/B logo.f836745bef4061aeaf68d4c1a1671a87.svg";
export { ForwardRef as ReactComponent };